import { Routes } from '@angular/router';
import { authGuard } from './core/firebase/auth.guard';
import { LoginPage } from './features/auth/pages/login/login.page';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'builder/content' },
  { path: 'login', component: LoginPage },
  {
    path: 'builder',
    canActivate: [authGuard],
    loadComponent: () =>
        import('./features/builder/layouts/builder-layout.page').then(
            (m) => m.BuilderLayoutPage
        ),
    children: [
      {
        path: 'content',
        loadComponent: () =>
            import('./features/builder/pages/content-dashboard/content-dashboard.page').then(
                (m) => m.ContentDashboardPage
            ),
      },
      {
        path: 'content/exercise-jobs-dashboard',
        loadComponent: () =>
            import('./features/builder/pages/content-exercise-jobs-dashboard/content-exercise-jobs-dashboard.page').then(
                (m) => m.ContentExerciseJobsDashboardPage
            ),
      },
      {
        path: 'content/exercise-jobs-dashboard/:jobId',
        loadComponent: () =>
            import('./features/builder/pages/content-exercise-job-detail/content-exercise-job-detail.page').then(
                (m) => m.ContentExerciseJobDetailPage
            ),
      },
      {
        path: 'content/exercises',
        loadComponent: () =>
            import('./features/builder/pages/content-exercises/content-exercises.page').then(
                (m) => m.ContentExercisesPage
            ),
      },
      {
        path: 'content/passages',
        loadComponent: () =>
            import('./features/builder/pages/content-passages/content-passages.page').then(
                (m) => m.ContentPassagesPage
            ),
      },
      {
        path: 'content/image-upload',
        loadComponent: () =>
            import('./features/builder/pages/content-image-upload/content-image-upload.page').then(
                (m) => m.ContentImageUploadPage
            ),
      },
      {
        path: 'content/image-import',
        loadComponent: () =>
            import('./features/builder/pages/content-image-import/content-image-import.page').then(
                (m) => m.ContentImageImportPage
            ),
      },
      {
        path: 'content/notifications',
        loadComponent: () =>
            import('./features/builder/pages/content-notifications/content-notifications-list.page').then(
                (m) => m.ContentNotificationsListPage
            ),
      },
      {
        path: 'content/notifications/create',
        loadComponent: () =>
            import('./features/builder/pages/content-notifications/content-notifications-create.page').then(
                (m) => m.ContentNotificationsCreatePage
            ),
      },
      {
        path: 'content/practice-generation-configs',
        loadComponent: () =>
            import('./features/builder/pages/practice-generation-configs/practice-generation-configs-list.page').then(
                (m) => m.PracticeGenerationConfigsListPage
            ),
      },
      {
        path: 'content/practice-generation-configs/create',
        loadComponent: () =>
            import('./features/builder/pages/practice-generation-configs/practice-generation-configs-editor.page').then(
                (m) => m.PracticeGenerationConfigsEditorPage
            ),
      },
      {
        path: 'content/practice-generation-configs/:id/edit',
        loadComponent: () =>
            import('./features/builder/pages/practice-generation-configs/practice-generation-configs-editor.page').then(
                (m) => m.PracticeGenerationConfigsEditorPage
            ),
      },
      {
        path: 'content/practice-generation-configs/:id/topics-catalog',
        loadComponent: () =>
            import('./features/builder/pages/practice-generation-configs/practice-generation-configs-topics-catalog.page').then(
                (m) => m.PracticeGenerationConfigsTopicsCatalogPage
            ),
      },
      {
        path: 'content/passages/my',
        loadComponent: () =>
            import('./features/exercise-builder/pages/passages/my-passages-page').then(
                (m) => m.MyPassagesPage
            ),
      },
      {
        path: 'visual-learning-paths',
        loadComponent: () =>
            import('./features/builder/pages/visual-learning/visual-learning-paths-list/visual-learning-paths-list.page').then(
                (m) => m.VisualLearningPathsListPage
            ),
      },
      {
        path: 'visual-learning-paths/create',
        loadComponent: () =>
            import('./features/builder/pages/visual-learning/visual-learning-paths-wizard/visual-learning-path-wizard.page').then(
                (m) => m.VisualLearningPathWizardPage
            ),
      },
      {
        path: 'visual-learning-paths/:id/edit',
        loadComponent: () =>
            import('./features/builder/pages/visual-learning/visual-learning-paths-wizard/visual-learning-path-wizard.page').then(
                (m) => m.VisualLearningPathWizardPage
            ),
      },

      // Visual Learning Practices
      {
        path: 'visual-learning-practices',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practices/vlp-practices-list/visual-learning-practices-list.page').then(
                (m) => m.VisualLearningPracticesListPage
            ),
      },
      {
        path: 'visual-learning-practices/create',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practices/vlp-practices-editor/visual-learning-practices-editor.page').then(
                (m) => m.VisualLearningPracticesEditorPage
            ),
      },
      {
        path: 'visual-learning-practices/:id/edit',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practices/vlp-practices-editor/visual-learning-practices-editor.page').then(
                (m) => m.VisualLearningPracticesEditorPage
            ),
      },

      // NUEVO: Challenge Configurations
      {
        path: 'practice-challenge-configs',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practice-challenge/practice-challenge-configs-list/practice-challenge-configs-list.page').then(
                (m) => m.PracticeChallengeConfigsListPage
            ),
      },
      {
        path: 'practice-challenge-configs/create',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practice-challenge/practice-challenge-configs-editor/practice-challenge-configs-editor.page').then(
                (m) => m.PracticeChallengeConfigsEditorPage
            ),
      },
      {
        path: 'practice-challenge-configs/:id/edit',
        loadComponent: () =>
            import('./features/builder/pages/vlp-practice-challenge/practice-challenge-configs-editor/practice-challenge-configs-editor.page').then(
                (m) => m.PracticeChallengeConfigsEditorPage
            ),
      },

      {
        path: 'groups',
        children: [
          {
            path: 'list',
            loadComponent: () =>
                import('./features/builder/pages/groups-list/groups-list.page').then(
                    (m) => m.GroupsListPage
                ),
          },
          {
            path: 'create',
            children: [
              {
                path: '',
                pathMatch: 'full',
                loadComponent: () =>
                    import('./features/builder/pages/group-builder/group-builder.page').then(
                        (m) => m.GroupBuilderPage
                    ),
              },
              {
                path: 'exercises',
                loadComponent: () =>
                    import('./features/builder/pages/group-builder-exercises/group-builder-exercises.page').then(
                        (m) => m.GroupBuilderExercisesPage
                    ),
              },
            ],
          },
          {
            path: 'edit/:id',
            children: [
              {
                path: '',
                pathMatch: 'full',
                loadComponent: () =>
                    import('./features/builder/pages/group-builder/group-builder.page').then(
                        (m) => m.GroupBuilderPage
                    ),
              },
              {
                path: 'exercises',
                loadComponent: () =>
                    import('./features/builder/pages/group-builder-exercises/group-builder-exercises.page').then(
                        (m) => m.GroupBuilderExercisesPage
                    ),
              },
            ],
          },
        ],
      },
      {
        path: 'exercises/edit',
        loadComponent: () =>
            import('./features/exercise-builder/pages/edit-exercise/edit-exercise.page').then(
                (m) => m.EditExercisePage
            ),
      },
      {
        path: 'passages/edit',
        loadComponent: () =>
            import('./features/exercise-builder/pages/passages/edit-passage-page').then(
                (m) => m.EditPassagePage
            ),
      },
      {
        path: 'review-queue',
        loadComponent: () =>
            import('./features/builder/pages/review-queue/review-queue.page').then(
                (m) => m.ReviewQueuePage
            ),
      },
      {
        path: 'exercises/create',
        loadComponent: () =>
            import('./features/exercise-builder/pages/create-exercise/create-exercise.page').then(
                (m) => m.CreateExercisePage
            ),
      },
      {
        path: 'passages/create',
        loadComponent: () =>
            import('./features/exercise-builder/pages/passages/create-passage-page').then(
                (m) => m.CreatePassagePage
            ),
      },
      {
        path: 'images/create',
        loadComponent: () =>
            import('./features/exercise-builder/pages/create-exercise-image/create-exercise-image.page').then(
                (m) => m.CreateExerciseImagePage
            ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'content' },
    ],
  },
  { path: 'home', pathMatch: 'full', redirectTo: 'builder/content' },
  { path: '**', redirectTo: 'builder/content' },
];
